import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const AddFriendOutlineIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <circle cx={12} cy={6} r={4}></circle>
        <path d="M15 13.327A13.6 13.6 0 0 0 12 13c-4.418 0-8 2.015-8 4.5S4 22 12 22c5.687 0 7.331-1.018 7.807-2.5"></path>
        <circle cx={18} cy={16} r={4}></circle>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18 14.667v2.666M16.667 16h2.666"
        ></path>
      </g>
    </svg>
  );
};

export default AddFriendOutlineIcon;
